import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
// import ProfileFinalStep from 'views/user-components/pages/signup-profile/ProfileFinalStep';

import Test from 'views/admin-components/pages/Test';
// login option 3 routing
const AdminLogin = Loadable(lazy(() => import('views/admin-components/pages/authentication/AdminLogin')));
/* const CompanyLogin = Loadable(lazy(() => import('views/admin-components/company/CompanyLogin')));
const SignUp = Loadable(lazy(() => import('views/user-components/pages/signup/SignUpSteps')));
const ActivateAccount = Loadable(lazy(() => import('views/user-components/pages/ActivateAccount')));
const SmartGroupActivation = Loadable(lazy(() => import('views/user-components/pages/company-register/SmartGroupActivation')));
const SmartGroupRegister = Loadable(lazy(() => import('views/user-components/pages/company-register/SmartGroupRegister')));
const DashboardDefault = Loadable(lazy(() => import('views/admin-components/dashboard/Default/TotalIncomeDarkCard')));
const LandingPage = Loadable(lazy(() => import('views/user-components/pages/LandingPage/LandingPage')));
const SmartGroup = Loadable(lazy(() => import('views/user-components/pages/company-register/SmartGroup')));
const IconLandingPage = Loadable(lazy(() => import('views/landing-pages/Icon/Icon')));
const RainTreeLandingPage = Loadable(lazy(() => import('views/landing-pages/rain-tree/RainTree')));
const WealthPortLandingPage = Loadable(lazy(() => import('views/landing-pages/wealthport/WealthPort')));
*/

// for new W.A robinson.
// const SignIn = Loadable(lazy(() => import('views/user-components/pages/signin/SignIn')));
const SignIn = Loadable(lazy(() => import('views/user-components/pages/signin/SignIn')));
const ClientSignIn = Loadable(lazy(() => import('views/user-components/pages/signin/ClientSignIn')));

let loginType = localStorage.getItem('login_type');
const storedPermissions = localStorage.getItem('manager_permissions');
const parsedPermissions = storedPermissions ? JSON.parse(storedPermissions) : null;

const isAdminLogin = ((loginType === 'portfolio_manager_admin') || (loginType === 'admin')) && parsedPermissions ? true : false;
const isDashboardLogin = (loginType === 'portfolio_manager') || (loginType === 'dashboard_admin') ? true : false
const isClientLogin = loginType === 'client'

const PublicRoute = {
    path: '/',
    element: <MinimalLayout />,
    children: [

        {
            path: '/',
            element: isClientLogin ? <Navigate to={'/main'} /> : <ClientSignIn />, //redirect to sign page if not login super user.

        },
        {
            path: '/pm-dashboard-login',
            element: isDashboardLogin ? <Navigate to={'/client-list'} /> : <SignIn />, //redirect to sign page if not login super user.

        }, {
            path: '/test',
            element: <Test />
        },

        {
            path: '/admin',
            element: (isAdminLogin) ? <Navigate to={'/admin/asset-categories'} /> : <AdminLogin />
        },

        // { path: '*', element: isSuperUserLogin ? <DashboardDefault /> : <Navigate to={'/admin'} /> }, // NOT FOUND  PAGE
    ]
};
export default PublicRoute;
